import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const { processOAuthCallback } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        console.error('No session_id found in URL');
        navigate('/login', { replace: true });
        return;
      }

      // Process the OAuth callback
      const result = await processOAuthCallback(sessionId);

      if (result.success) {
        // Check if user has goals set
        if (result.user && (!result.user.goals || result.user.goals.length === 0)) {
          // Redirect to profile to set goals
          navigate('/profile', { replace: true, state: { showGoals: true } });
        } else {
          // Redirect to recommendations based on their goals
          navigate('/recommendations', { replace: true });
        }
      } else {
        console.error('OAuth failed:', result.error);
        navigate('/login', { replace: true, state: { error: result.error } });
      }
    };

    processAuth();
  }, [processOAuthCallback, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-capsule-bg to-rose-100">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-capsule-teal mx-auto mb-4" />
        <p className="text-gray-600">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
